module.exports = __webpack_public_path__ + "img/outbound.753654a1.svg";